/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LaundryWashmaster
 */
export interface LaundryWashmaster {
    /**
     * 
     * @type {string}
     * @memberof LaundryWashmaster
     */
    terminalSerialNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LaundryWashmaster
     */
    terminalPassword?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof LaundryWashmaster
     */
    posTerminalIds?: Array<string>;
}

/**
 * Check if a given object implements the LaundryWashmaster interface.
 */
export function instanceOfLaundryWashmaster(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function LaundryWashmasterFromJSON(json: any): LaundryWashmaster {
    return LaundryWashmasterFromJSONTyped(json, false);
}

export function LaundryWashmasterFromJSONTyped(json: any, ignoreDiscriminator: boolean): LaundryWashmaster {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'terminalSerialNumber': !exists(json, 'terminalSerialNumber') ? undefined : json['terminalSerialNumber'],
        'terminalPassword': !exists(json, 'terminalPassword') ? undefined : json['terminalPassword'],
        'posTerminalIds': !exists(json, 'posTerminalIds') ? undefined : json['posTerminalIds'],
    };
}

export function LaundryWashmasterToJSON(value?: LaundryWashmaster | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'terminalSerialNumber': value.terminalSerialNumber,
        'terminalPassword': value.terminalPassword,
        'posTerminalIds': value.posTerminalIds,
    };
}

